import React from 'react'
import './index.css'

export const DashBoardTitle = ({className, dashBorardName}) => {
    return (
        <h5 id='pageTitle' className={className ? className : ''}>{dashBorardName}</h5>
    )
}